export default __webpack_public_path__ + "static/media/fan-galleries4.9fb6ef5e.jpg";